
import { Search } from "lucide-react";
import { useTranslations } from "@/hooks/useTranslations";
import { Switch } from "@/components/ui/switch";

interface SessionsSearchProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  showStudentSessions: boolean;
  setShowStudentSessions: (show: boolean) => void;
}

export const SessionsSearch = ({
  searchTerm,
  setSearchTerm,
  showStudentSessions,
  setShowStudentSessions,
}: SessionsSearchProps) => {
  const { t } = useTranslations("training-sessions");

  return (
    <div className="relative flex flex-col gap-3 w-full sm:max-w-xs">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground dark:text-gray-400" />
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={t("filter.searchPlaceholder")}
          className="w-full pl-10 py-2 rounded-xl border border-slate-200 dark:border-gray-700 bg-white dark:bg-gray-800 dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-flame/40 dark:focus:ring-flame/60"
        />
      </div>
      <div className="flex items-center space-x-2">
        <Switch
          checked={showStudentSessions}
          onCheckedChange={setShowStudentSessions}
          className="data-[state=checked]:bg-flame"
        />
        <span className="text-sm text-slate-600 dark:text-slate-300">
          {t("filter.showStudentSessions")}
        </span>
      </div>
    </div>
  );
};
